module.exports = __webpack_public_path__ + "img/广宗童车.0ee77703.jpg";